module.exports = __webpack_public_path__ + "static/media/yandex-lite_256x256.9c64105f.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/browser-logos/src/yandex-lite/yandex-lite_256x256.png
// module id = 2865
// module chunks = 0